<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text v-bind="attrs" v-on="on">體系院所藥品查詢</v-btn>
        </template>
        <span>{{ wsdMsg.VUE_APP_RUN }}</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <v-spacer v-if="$store.state.isLogin">
        {{ $store.state.isAdmin ? "管理者" : "登入者" }}
        ：
        {{ $store.state.userId }}
        ／
        {{ $store.state.userNa }}
      </v-spacer>

      <v-btn href="http://www.cych.org.tw/" text>
        <span class="mr-2">嘉基官網</span>
      </v-btn>

      <v-btn v-if="$store.state.isLogin" text @click="logout">
        <span class="mr-2">登出</span>
      </v-btn>
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    wsdMsg: {
      NODE_ENV: process.env.NODE_ENV,
      VUE_APP_RUN: process.env.VUE_APP_RUN,
    },
  }),
  mounted() {
    // console.log(this.wsdMsg);
  },
  methods: {
    logout() {
      if (confirm("是否登出？")) {
        this.$store.commit("setLogIn", false);
        this.$router.push("/login");
      }
    },
  },
};
</script>
